import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { StartWorkService } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize, take, tap } from 'rxjs/operators';
import StartWorkModel from './start-work.model';

@Component({
    selector: 'pace-start-work',
    templateUrl: './start-work.component.html',
    styleUrls: ['./start-work.component.scss'],
    standalone: false,
})
export class StartWorkComponent {
    @Input()
    public model: StartWorkModel;

    @Output()
    public startWorkAdded = new EventEmitter<boolean>();
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        public readonly modalInstance: BsModalRef,
        private readonly startWorkService: StartWorkService,
    ) {}

    public saveStartWork(): void {
        this.startWorkService
            .setStartOfWork(this.model.startOfWork)
            .pipe(
                take(1),
                tap({
                    next: () => {
                        this.log.debug(`StartWorkComponent: saveStartWork: set startOfWork: ${this.model.startOfWork}`);
                        this.startWorkAdded.emit(true);
                    },
                    error: (error) => {
                        this.log.warn(
                            `StartWorkComponent: saveStartWork: could not set startOfWork due to error:`,
                            error,
                        );
                    },
                }),
                finalize(() => this.modalInstance.hide()),
            )
            .subscribe();
    }
}
